module.exports = __webpack_public_path__ + "yt.b07a5fddb744e74592be.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/yt.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/yt.svg
// module chunks = styles